import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ToggleGroup } from '../../../models/utility/toggle-group.model';
import { FiltersUtilityService } from '../../../services/filters-utility.service';

@Component({
  standalone: false,
  selector: 'suvo-bi-nested-checkboxes',
  templateUrl: './nested-checkboxes.component.html',
  styleUrls: ['./nested-checkboxes.component.scss'],
})
export class NestedCheckboxesComponent {
  @Input() toggleGroups: ToggleGroup[];

  constructor(
    private filtersService: FiltersUtilityService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  parentCheckedChanged(toggleGroup, ev) {
    toggleGroup.setChecked(ev.checked);
    toggleGroup.indeterminate = false;
  }

  childCheckedChanged() {
    this.filtersService.updateParentState(this.toggleGroups);
    this.changeDetectorRef.markForCheck();
  }
}
